import * as React from 'react';
import {
  Button,
  PageSection,
  Title
} from '@patternfly/react-core';
import { SUPPORT_EMAIL, PRODUCT_NAME } from '../../config/partner';

export interface IErrorProps {
  sampleProp?: string;
}

const currentDateTime = new Date().toLocaleString();

// eslint-disable-next-line prefer-const
let Error: React.FunctionComponent<IErrorProps> = () => (
  <PageSection hasBodyWrapper={false}>
    <Title headingLevel="h1" size="xl">Error</Title>

      <p>{currentDateTime} An error has occurred and our support team have been notified.</p>
      <p>Please <Button variant="primary" component="a" href={`mailto:${SUPPORT_EMAIL}?subject=${PRODUCT_NAME} error at ${currentDateTime}`}> Contact Support</Button> for further assistance.</p>

  </PageSection>
);

export { Error };
